module.exports = __webpack_public_path__ + "static/fipcnavyteddy1-f87be7a956afc187606235bb32632b72.jpeg";